<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="教师所属学校id" prop="schoolId">
      <el-input v-model="dataForm.schoolId" placeholder="教师所属学校id"></el-input>
    </el-form-item>
    <el-form-item label="教师名称" prop="name">
      <el-input v-model="dataForm.name" placeholder="教师名称"></el-input>
    </el-form-item>
    <el-form-item label="头像链接" prop="avatar">
      <el-input v-model="dataForm.avatar" placeholder="头像链接"></el-input>
    </el-form-item>
    <el-form-item label="登录账号" prop="username">
      <el-input v-model="dataForm.username" placeholder="登录账号"></el-input>
    </el-form-item>
    <el-form-item label="登录密码" prop="password">
      <el-input v-model="dataForm.password" placeholder="登录密码"></el-input>
    </el-form-item>
    <el-form-item label="创建时间" prop="createTime">
      <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
    </el-form-item>
    <el-form-item label="更新时间" prop="updateTime">
      <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          schoolId: '',
          name: '',
          avatar: '',
          username: '',
          password: '',
          createTime: '',
          updateTime: ''
        },
        dataRule: {
          schoolId: [
            { required: true, message: '教师所属学校id不能为空', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '教师名称不能为空', trigger: 'blur' }
          ],
          avatar: [
            { required: true, message: '头像链接不能为空', trigger: 'blur' }
          ],
          username: [
            { required: true, message: '登录账号不能为空', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '登录密码不能为空', trigger: 'blur' }
          ],
          createTime: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ],
          updateTime: [
            { required: true, message: '更新时间不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/business/teacher/info/${this.dataForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.dataForm.schoolId = data.teacher.schoolId
                this.dataForm.name = data.teacher.name
                this.dataForm.avatar = data.teacher.avatar
                this.dataForm.username = data.teacher.username
                this.dataForm.password = data.teacher.password
                this.dataForm.createTime = data.teacher.createTime
                this.dataForm.updateTime = data.teacher.updateTime
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/business/teacher/${!this.dataForm.id ? 'save' : 'update'}`),
              method: 'post',
              data: this.$http.adornData({
                'id': this.dataForm.id || undefined,
                'schoolId': this.dataForm.schoolId,
                'name': this.dataForm.name,
                'avatar': this.dataForm.avatar,
                'username': this.dataForm.username,
                'password': this.dataForm.password,
                'createTime': this.dataForm.createTime,
                'updateTime': this.dataForm.updateTime
              })
            }).then(({data}) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
